import React from 'react';
import { connect } from 'react-redux';
import { ApplicantQualificationDetails } from '../../api/ApiClient';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { Qualifications, QualificationInfoDetails } from 'components';
import { useLocalErrorHandler } from 'hooks';

const ApplicantQualificationsContainer = ({
    getQualificationsList,
    qualificationsList,
    apiError, 
    setErrorHandler,
    getApplicantQualificationDetails,
    qualificationDetails,
}: Props) => {
    useLocalErrorHandler(setErrorHandler);

    React.useEffect(() => {
        setSelectedQualification(qualificationDetails);
    }, [qualificationDetails]);

    const [selectedQualification, setSelectedQualification] = React.useState<ApplicantQualificationDetails | null>(null);
    const [showErrorModal, setShowErrorModal] = React.useState(false);

    React.useEffect(() => {
        setSelectedQualification(null);
        const fetch = async () => {
            await getQualificationsList();
        };

        fetch();
    }, []);

    const onQualificationListRowClick = async (examApplicationId: string) => {
        const res = await getApplicantQualificationDetails(examApplicationId);

        if (!res) {
            setShowErrorModal(true);
        }
    };

    if (selectedQualification) {
        return (
            <QualificationInfoDetails
              qualificationDetails={selectedQualification}
              onBackClick={() => setSelectedQualification(null)}
              cardCategory="Список квалификаций, присвоенных вам, как соискателю"
            />
        );
    }

    return (
        <Qualifications
          cardTitle="Мои квалификации"
          cardCategory="Список присвоенных квалификаций"
          qualificationsList={qualificationsList}
          apiError={apiError}
          onQualificationListRowClick={onQualificationListRowClick}
          showErrorModal={showErrorModal}
          onHideErrorModal={() => setShowErrorModal(false)}
        />
    );
};

const mapState = (state: IRootState) => ({
    qualificationDetails: state.applicant.qualificationDetails,
    qualificationsList: state.applicant.qualificationsList,
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    setErrorHandler:dispatch.errors.setErrorHandler,
    getQualificationsList: dispatch.applicant.getQualificationsListAsync,
    getApplicantQualificationDetails: dispatch.applicant.getQualificationDetailsAsync,
});

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>
type Props = connectedProps;

export default connect(mapState, mapDispatch)(ApplicantQualificationsContainer);
